import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import MaterialCircularProgress, {
  CircularProgressProps as MaterialCircularProgressProps
} from '@material-ui/core/CircularProgress';

const useStyles = (size: number, x = 50, y = 50): Function =>
  makeStyles<Theme>(() => {
    const xOffset = `calc(${x}% - ${size / 2}rem)`;
    const yOffset = `calc(${y}% - ${size / 2}rem)`;
    return {
      spinner: {
        position: 'relative',
        margin: '0 auto',
        top: yOffset,
        left: xOffset
      }
    };
  });

export interface LoadingSpinnerProps extends MaterialCircularProgressProps {
  size?: number;
  xOffset?: number;
  yOffset?: number;
}

const LoadingSpinnerWithoutOverlay: React.FC<LoadingSpinnerProps> = ({
  color = 'primary',
  size = 6.5,
  thickness,
  xOffset,
  yOffset,
  ...rest
}) => {
  const classes = useStyles(size, xOffset, yOffset)();

  return (
    <MaterialCircularProgress
      className={classes.spinner}
      color={color}
      size={`${size}rem`}
      thickness={thickness || size * 0.7}
      {...rest}
    />
  );
};

export default LoadingSpinnerWithoutOverlay;
